import {
  APPLY_FILTER
} from '../actions';

const initialState = {
  start_date:        undefined,
  state_code:        undefined,
  active_only:     false,
  needs_providers: false,
  per_page:        10,
  page:            1,
  service_specialty_code: undefined,
  context_code:    'PROVIDERINCENTIVECONTEXT_SHIFT'
};

const requestFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPLY_FILTER:
      return {
        ...state,
        ...action.filter
      };
    default:
      return state;
  }
};

export default requestFilterReducer;
